import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;

  // position can be top or bottom

  width: 100%;
  height: min-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PaperBorder = ({ variant = 1, color = '#fff', position = 'top' }) => {
  if (variant === 1) {
    return (
      <Container position={position}>
        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 200 1280 100" width="1280" height="100">
          <path
            fill={color}
            d="m0-80.4v369.4l2.7 0.3 13.3-2.1 13.5 0.2 13-2.8 16.3 3.6 7-14 11.8 0.3 14.9 1.6 17-1.8 14.9-3.3 14.3 2.7 14.7-3.2 13.7 10.9 14.9-9.4 14.2 5.6 14.4 5.8 14.5 1.9 14.5-3 14.1-10.3 14.6 3.8 14.8 5.3 14.4-2.1 14.8 2.5 12.9-7.1 13.6-0.2 13.7-4.7 13.3 0.2 13.5 2 13.1-2.4 7.5-10 8.8-8 10.8-7.8 18.4 4.1 14-4.8 13.9-11 13.7-3.3 14.7 0.6 10.7-6.9 10.5-6.4 11.8-2.5 16.2-2.6 14.3-6.9 13.6-7.9 14.9-7.5 14.6 8.8 13.3-5 13.9 2.6 13.5-2.3 13.6 3.2 14.1-11.4 13.1 8.5 13.6 0.8 16.1 15.4 17.4-10.6 16.6 8.1 12.2-5.5 12.3-1.1 12.7 6.5 12-0.2 14.5-2.8 16.8-3.8 13.6 7.5 13 7.9 12.6 7.8 8.1 15 13.5 6.5 16.8-2 10.2 13.1 14.1 0.8 14.2-3.3 13.1 8.9 13.9-5 13.8 7.6 13.6-6.2 13.8-0.3 13.9 4.2 13.6-2.4 13.4-7.9 13.8 9.7 13.3-0.4 13.3-11.1 13.4 6.7 13.3-4.3 13.3-4.1 13.6 13.1 13.4-2.4 13-7 13.3-1.4 15 0.2 13.7-6.1 15.3-0.8 12.2-10 13.4-3.1 13.7 5.3 11.3-0.3v-316.2z"
          />
        </svg>
      </Container>
    );
  }

  if (variant === 2) {
    return (
      <Container position={position}>
        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 100 1280 100" width="1280" height="100">
          <path
            fill={color}
            d="m0-185v337c3.4-1.1 10.1 0.4 13.8 8.4 2.9-8.5 18.3-29.2 20.4-9.2 1.6-3 18.5-13.7 22.5-6.7 2.5-3.3 17 0.6 19.3-2.5 1.1 1.3 24.4-11.3 24.4-12.5 0-4.4 20.1 19.4 20.1 12.7 0-14.1 18 17.3 18 16 0-0.8 21.9-3.1 21.9-0.8 0 0.8 20.4 2 20.4 3.4 0-3.4 20.7 7.5 20.7 10.6 0 0.2 19.5-16.3 19.5-17.9 0 18.3 22.1 7.9 22.1 6.8 0-0.3 20.5-11.3 20.5-5.2 0-1.5 18.6-11.1 18.6-13.1 0-2.2 21.5-17.7 21.5-5.2 0 8.4 20.6-22.5 20.6-16.4 0 2.5 24.3 19.8 24.3 10.8 0-2.2 19.4-11.2 19.4-4 0 12.2 19.5-13.6 19.5-9.8 0 2.4 19.8 12.5 19.8 8.8 0 8.4 19.9-18.7 19.9-8.4 0 0.9 19.6 1.8 19.6 3.5 0 6 19.2 3.9 19.2 9 0 2.5 19.4-1.5 19.4 2.6 0-4.8 20.4-4.3 20.4-5.5 0 7.9 19.6 7 19.6 2.6 0-4.9 19.4 10.7 19.4 3.6 0 4.6 18.3 9.3 18.3 9.7 0 1.1 19.1 8.8 19.1 3.9 0 7.8 18.4 10.8 18.4 9.7 0 1.6 19.9-1.5 19.9 2.4 0-8.7 21 5.4 21-1.3 0 4.6 17.6 7.8 17.6 12 0-10.7 22.8-3.2 22.8-7.9 0 1.4 19.7-5.4 19.7 3.6 0-13.6 16.7 8.2 16.7 15.3 0 15.1 19.9 0.7 19.9 3.3 0 2.4 21.3-18.2 21.3-4.2 0 4.8 18.1 20.7 18.1 10.7 0 0.2 19.7 7.7 19.7 3.8 0-14.4 20.3 9.3 20.3-2.3 0-0.5 18.4 12.9 18.4 19.4 0 13.9 20.8-4.4 20.8-12.7 0 2.6 20.3 5.9 20.3 13.1 0-5.1 20-5 20-7.4 0-8.4 20.3 2.9 20.3-1.4 0-9.6 19.4-9.5 19.4-10.1 0 6.6 20.8-4.5 20.8-7.5 0 2.3 21.4 3.7 21.4 7.4 0 0.7 22.6-2.1 22.6 9.2 0 14.5 22.5 8.5 22.5 6.3 0-10.6 15.1 6.2 15.1 8.6 0 8.2 17.2 12.4 17.2 3.9 0-23.6 16.2-8.6 16.2-10.6 0-6.5 21 8.7 21 10 0 11.2 18.4-10.1 18.4-18.4 0-3.2 21.3 8.1 21.3 14 0-10.7 22.1 1 19.3-8.3 0.9 3.7 21.3 6.1 20.2 0.7 1.6 2.1 16.7-6.5 19.6-1.1-4.5-17.1 15.3-6.5 20.6 2.7 0.5-3.4 18.2-6.6 19.4-6.4-3.6-3.2 22.8-7 19.4-7.2 1.4-1 20.1-6.7 19.9-6.1 0.4 7.6 3.9 11.9 7.9 13.8v-389.2z"
          />
        </svg>
      </Container>
    );
  }

  return null;
};
